"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _search = _interopRequireDefault(require("@spothero/icons/search"));

var _environment = _interopRequireDefault(require("@spothero/utils/environment"));

var _AutoSuggestInput = _interopRequireDefault(require("../AutoSuggestInput/AutoSuggestInput"));

var _TextInputPropTypes = _interopRequireDefault(require("../TextInput/TextInputPropTypes"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(source, true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(source)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var GooglePlacesSearchInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(GooglePlacesSearchInput, _Component);

  function GooglePlacesSearchInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GooglePlacesSearchInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GooglePlacesSearchInput).call(this, props));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onChange", function (evt) {
      var onChange = _this.props.onChange;
      var autocompleteSessionToken = _this.state.autocompleteSessionToken;
      var value = evt.target.value;

      if (!autocompleteSessionToken) {
        _this.setState({
          autocompleteSessionToken: new _this._gmaps.places.AutocompleteSessionToken()
        });
      }

      if (!value || value.length < 3) {
        _this.setState({
          suggestions: []
        });
      } else {
        _this._suggestionFetch(value);
      }

      if (onChange) {
        onChange(evt);
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onSuggestionSelect", function (suggestion) {
      var onSuggestionSelect = _this.props.onSuggestionSelect;
      var placeId = suggestion.place_id,
          description = suggestion.description;

      if (suggestion.location) {
        onSuggestionSelect(suggestion);
      } else {
        _this._geocoder.geocode(placeId ? {
          placeId: placeId
        } : {
          address: description
        }, function (results, status) {
          if (status !== _this._gmaps.GeocoderStatus.OK) {
            return;
          }

          var gmaps = results[0];
          var geoCodedLocation = gmaps.geometry.location;
          suggestion.label = description;
          suggestion.gmaps = gmaps;
          suggestion.location = {
            lat: geoCodedLocation.lat(),
            lng: geoCodedLocation.lng()
          };
          onSuggestionSelect(suggestion);
        });
      }

      _this.setState({
        autocompleteSessionToken: null
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_searchSuggestions", function (value) {
      var _this$props = _this.props,
          country = _this$props.country,
          types = _this$props.types,
          bounds = _this$props.bounds;
      var autocompleteSessionToken = _this.state.autocompleteSessionToken;

      var options = _objectSpread({
        input: value
      }, bounds && {
        bounds: bounds
      }, {}, country && {
        componentRestrictions: {
          country: country
        }
      }, {}, types && {
        types: types
      }, {
        sessionToken: autocompleteSessionToken
      });

      _this._autocompleteService.getPlacePredictions(options, function (suggestions) {
        if (suggestions) {
          (0, _map.default)(suggestions).call(suggestions, function (suggestion) {
            suggestion.label = suggestion.description;
            return suggestion;
          });
        }

        _this.setState({
          suggestions: suggestions
        });
      });
    });
    var googleMaps = props.googleMaps;

    var isBrowser = _environment.default.isBrowser();

    _this._suggestionFetch = (0, _throttle.default)(_this._searchSuggestions, 500);
    _this._gmaps = googleMaps;
    _this._autocompleteService = isBrowser ? new _this._gmaps.places.AutocompleteService() : null;
    _this._geocoder = isBrowser ? new _this._gmaps.Geocoder() : null;
    _this.state = {
      suggestions: [],
      autocompleteSessionToken: isBrowser ? new _this._gmaps.places.AutocompleteSessionToken() : null
    };
    return _this;
  }

  (0, _createClass2.default)(GooglePlacesSearchInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          poweredByGoogleFooter = _this$props2.poweredByGoogleFooter,
          types = _this$props2.types,
          country = _this$props2.country,
          onClear = _this$props2.onClear,
          textInputProps = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "poweredByGoogleFooter", "types", "country", "onClear"]);
      var suggestions = this.state.suggestions;
      var classes = (0, _classnames.default)('GooglePlacesSearchInput', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_AutoSuggestInput.default, (0, _extends2.default)({
        ref: function ref(node) {
          _this2._autosuggest = node;
        }
      }, textInputProps, {
        onChange: this._onChange,
        suggestions: suggestions,
        types: types,
        country: country,
        suggestionBoxFooter: poweredByGoogleFooter,
        onClear: onClear,
        onSuggestionSelect: this._onSuggestionSelect,
        autoActivateFirstSuggest: true
      })));
    }
  }, {
    key: "node",

    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */
    get: function get() {
      return this._autosuggest.node;
    }
  }]);
  return GooglePlacesSearchInput;
}(_react.Component);

exports.default = GooglePlacesSearchInput;
(0, _defineProperty3.default)(GooglePlacesSearchInput, "defaultProps", {
  placeholder: 'Search Address or Venue',
  country: 'us',
  icon: _react.default.createElement(_search.default, null)
});